import { useBooleanFlagValue } from '@openfeature/react-sdk';
import { PermissionEnum } from '@thro-types/access-handler';
import { User } from '@thro-types/users';

import { useLayoutEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { Route, Routes, useNavigate } from 'react-router';

import PrivateRoute from 'app/components/Util/PrivateRoute';
import { translations } from 'locales/i18n';
import { FEATURE_FLAGS } from 'utils/featureFlags';

import { AlertActions } from '../Dashboard/Alert/slice';
import ElectionAdminPage from './Elections';
import ElectionDetailPage from './Elections/DetailPage';
import ElectionEditPage from './Elections/EditPage';
import MyElections from './MyElections';

interface Props {
  currentUser: User;
  userPermission: PermissionEnum[];
}
export const Polyas = ({ currentUser, userPermission }: Props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isPolyasEnabled = useBooleanFlagValue(FEATURE_FLAGS.POLYAS.ENABLED, false);

  useLayoutEffect(() => {
    if (!isPolyasEnabled) {
      navigate('/');
      dispatch(AlertActions.warning(t(translations.common.areaCurrentlyDisabled())));
    }
  }, [dispatch, isPolyasEnabled, navigate, t]);

  return (
    <Routes>
      <Route
        path="my"
        element={
          <PrivateRoute user={currentUser} notAnonymous>
            <MyElections currentUser={currentUser} />
          </PrivateRoute>
        }
      />
      <Route
        path="admin"
        element={
          <PrivateRoute user={currentUser} notAnonymous>
            <ElectionAdminPage currentUser={currentUser} />
          </PrivateRoute>
        }
      />
      <Route
        path="admin/:id"
        element={
          <PrivateRoute user={currentUser} notAnonymous>
            <ElectionDetailPage currentUser={currentUser} />
          </PrivateRoute>
        }
      />
      <Route
        path="admin/edit"
        element={
          <PrivateRoute user={currentUser} notAnonymous>
            <ElectionEditPage currentUser={currentUser} />
          </PrivateRoute>
        }
      />
      <Route
        path="admin/edit/:id"
        element={
          <PrivateRoute user={currentUser} notAnonymous>
            <ElectionEditPage currentUser={currentUser} />
          </PrivateRoute>
        }
      />
    </Routes>
  );
};
